export const modernDarkTheme = {
  'code[class*="language-"]': {
    color: '#c0caf5',
    fontFamily: 'var(--font-code-modern)',
    background: '#1a1b26',
    lineHeight: '1.7',
    tabSize: 1,
  },
  'pre[class*="language-"]': {
    color: '#c0caf5',
    fontFamily: 'var(--font-code-modern)',
    background: '#1a1b26',
    lineHeight: '1.7',
    tabSize: 1,
  },
  'comment': { color: '#565f89', fontStyle: 'italic' },
  'prolog': { color: '#565f89' },
  'doctype': { color: '#565f89' },
  'cdata': { color: '#565f89' },
  'punctuation': { color: '#7aa2f7' },
  'property': { color: '#c0caf5' },
  'tag': { color: '#bb9af7' },
  'boolean': { color: '#ff9e64' },
  'number': { color: '#ff9e64' },
  'constant': { color: '#f7768e' },
  'symbol': { color: '#f7768e' },
  'deleted': { color: '#f7768e', fontStyle: 'italic' },
  'selector': { color: '#bb9af7' },
  'attr-name': { color: '#7dcfff' },
  'string': { color: '#9ece6a' },
  'char': { color: '#9ece6a' },
  'builtin': { color: '#7dcfff' },
  'inserted': { color: '#9ece6a', fontStyle: 'italic' },
  'operator': { color: '#7aa2f7' },
  'entity': { color: '#ff9e64', cursor: 'help' },
  'url': { color: '#7aa2f7', textDecoration: 'underline' },
  'variable': { color: '#c0caf5' },
  'atrule': { color: '#bb9af7' },
  'attr-value': { color: '#9ece6a' },
  'function': { color: '#7dcfff' },
  'class-name': { color: '#7dcfff' },
  'keyword': { color: '#bb9af7' },
  'regex': { color: '#ff9e64' },
  'important': { color: '#f7768e', fontWeight: 'bold' },
  'bold': { fontWeight: 'bold' },
  'italic': { fontStyle: 'italic' },
  '.namespace': { opacity: 0.8 },
  'token.tab:not(:empty):before': { color: '#565f89' },
  'token.cr:before': { color: '#565f89' },
  'token.lf:before': { color: '#565f89' },
  'token.space:before': { color: '#565f89' },
};

export const modernLightTheme = {
  'code[class*="language-"]': {
    color: '#343b58',
    fontFamily: 'var(--font-code-modern)',
    background: '#f4f4f8',
    lineHeight: '1.7',
    tabSize: 1,
  },
  'pre[class*="language-"]': {
    color: '#343b58',
    fontFamily: 'var(--font-code-modern)',
    background: '#f4f4f8',
    lineHeight: '1.7',
    tabSize: 1,
  },
  'comment': { color: '#9096b0', fontStyle: 'italic' },
  'prolog': { color: '#9096b0' },
  'doctype': { color: '#9096b0' },
  'cdata': { color: '#9096b0' },
  'punctuation': { color: '#0969da' },
  'property': { color: '#343b58' },
  'tag': { color: '#a750d5' },
  'boolean': { color: '#cf6100' },
  'number': { color: '#cf6100' },
  'constant': { color: '#d73a49' },
  'symbol': { color: '#d73a49' },
  'deleted': { color: '#d73a49', fontStyle: 'italic' },
  'selector': { color: '#a750d5' },
  'attr-name': { color: '#0550ae' },
  'string': { color: '#1f883d' },
  'char': { color: '#1f883d' },
  'builtin': { color: '#0550ae' },
  'inserted': { color: '#1f883d', fontStyle: 'italic' },
  'operator': { color: '#0969da' },
  'entity': { color: '#cf6100', cursor: 'help' },
  'url': { color: '#0969da', textDecoration: 'underline' },
  'variable': { color: '#343b58' },
  'atrule': { color: '#a750d5' },
  'attr-value': { color: '#1f883d' },
  'function': { color: '#0550ae' },
  'class-name': { color: '#0550ae' },
  'keyword': { color: '#a750d5' },
  'regex': { color: '#cf6100' },
  'important': { color: '#d73a49', fontWeight: 'bold' },
  'bold': { fontWeight: 'bold' },
  'italic': { fontStyle: 'italic' },
  '.namespace': { opacity: 0.8 },
  'token.tab:not(:empty):before': { color: '#9096b0' },
  'token.cr:before': { color: '#9096b0' },
  'token.lf:before': { color: '#9096b0' },
  'token.space:before': { color: '#9096b0' },
};